import { api } from '$shared/api';

declare global {
  interface Window {
    MusicKit?: any;
  }
}

let scriptLoaded = false;

function loadMusicKitScript(): Promise<void> {
  if (scriptLoaded || window.MusicKit) {
    scriptLoaded = true;
    return Promise.resolve();
  }
  return new Promise((resolve, reject) => {
    const s = document.createElement('script');
    s.src = 'https://js-cdn.music.apple.com/musickit/v3/musickit.js';
    s.async = true;
    s.onload = () => {
      scriptLoaded = true;
      resolve();
    };
    s.onerror = () => reject(new Error('Failed to load Apple MusicKit'));
    document.head.appendChild(s);
  });
}

/**
 * Connect Apple Music: fetch a developer token, load + configure MusicKit JS,
 * prompt the user (popup) for a Music User Token, then POST it to the backend
 * connect endpoint. Throws on failure / not-configured.
 */
export async function connectAppleMusic(): Promise<void> {
  const { developer_token, configured } = await api.get<{
    developer_token: string | null;
    configured: boolean;
  }>('/auth/apple-music/token');
  if (!configured || !developer_token) {
    throw new Error('Apple Music is not configured');
  }

  await loadMusicKitScript();
  const MK = window.MusicKit;
  await MK.configure({
    developerToken: developer_token,
    app: { name: 'Beat Duel', build: '1.0.0' },
  });
  const music = MK.getInstance();
  const musicUserToken: string = await music.authorize(); // opens Apple auth popup
  await api.post('/auth/apple-music/connect', { music_user_token: musicUserToken });
}

export async function disconnectAppleMusic(): Promise<void> {
  await api.post('/auth/apple-music/disconnect', {});
}
